// @ts-nocheck
import ReactQuill from 'react-quill-new';
import 'react-quill-new/dist/quill.snow.css';
import { Label } from '@/components/ui/label';
import { Button } from '@/components/ui/button';
import SectionCard from './SectionCard';

const QUILL_MODULES = {
  toolbar: [
    [{ header: [1, 2, 3, false] }],
    ['bold', 'italic', 'underline', 'strike'],
    [{ color: [] }, { background: [] }],
    [{ list: 'ordered' }, { list: 'bullet' }],
    [{ indent: '-1' }, { indent: '+1' }],
    ['link'],
    ['clean'],
  ],
};
// Quill 2: 'bullet' is not a format — bullet lists are values of 'list'
// (listing it here makes Quill log a registry error and register nothing).
const QUILL_FORMATS = [
  'header', 'bold', 'italic', 'underline', 'strike',
  'color', 'background', 'list', 'indent', 'link',
];

export default function LegalSection({ d, waivers, registrationName }) {
  const { draft, setField, dirtyBySection, savingSection, saveSection } = d;
  const selected = draft.selectedWaivers || [];

  const toggleWaiver = (waiverId) => {
    setField(
      'selectedWaivers',
      selected.includes(waiverId) ? selected.filter((id) => id !== waiverId) : [...selected, waiverId],
    );
  };

  return (
    <SectionCard
      id="legal"
      title="Legal Agreements"
      description="Optional release statement teams agree to, and waivers each player must sign."
      dirty={dirtyBySection.legal}
      saving={savingSection === 'legal'}
      onSave={() => saveSection('legal')}
    >
      <div className="space-y-2">
        <Label className="text-base font-medium">Release statement</Label>
        <p className="text-sm text-muted-foreground">
          Shown to the team during registration; leave empty to skip it.
        </p>
        <div className="quill-editor">
          <ReactQuill
            placeholder={`By participating in the ${registrationName || 'league'}, the team and its members acknowledge and assume all risks associated with the sport…`}
            value={draft.releaseStatement}
            onChange={(v) => setField('releaseStatement', v)}
            modules={QUILL_MODULES}
            formats={QUILL_FORMATS}
          />
        </div>
      </div>

      <div className="space-y-3">
        <div className="flex items-center justify-between">
          <Label className="text-base font-medium">Player waivers</Label>
          {waivers.length > 0 && (
            <div className="flex gap-2">
              <Button
                type="button"
                variant="outline"
                size="sm"
                onClick={() => setField('selectedWaivers', waivers.map((w) => w._id))}
                disabled={selected.length === waivers.length}
              >
                Select all
              </Button>
              <Button
                type="button"
                variant="outline"
                size="sm"
                onClick={() => setField('selectedWaivers', [])}
                disabled={selected.length === 0}
              >
                Deselect all
              </Button>
            </div>
          )}
        </div>
        {waivers.length > 0 ? (
          <div className="max-h-48 space-y-2 overflow-y-auto rounded-lg border p-3">
            {waivers.map((waiver) => (
              <div key={waiver._id} className="flex items-center gap-2">
                <input
                  type="checkbox"
                  id={`waiver-${waiver._id}`}
                  checked={selected.includes(waiver._id)}
                  onChange={() => toggleWaiver(waiver._id)}
                  className="rounded border-input text-primary focus:ring-ring"
                />
                <Label htmlFor={`waiver-${waiver._id}`} className="flex-1 cursor-pointer text-sm font-medium">
                  {waiver.title || waiver.name}
                </Label>
              </div>
            ))}
          </div>
        ) : (
          <div className="rounded-lg bg-muted/50 p-3 text-sm text-muted-foreground">
            <p>No finalized waivers are available for this organization yet.</p>
            <p className="mt-1">
              <a href="/admin/waivers" target="_blank" rel="noopener noreferrer" className="text-primary hover:underline">
                Create and finalize a player waiver
              </a>
            </p>
          </div>
        )}
        {selected.length > 0 && (
          <p className="text-sm text-muted-foreground">
            {selected.length} waiver{selected.length !== 1 ? 's' : ''} required per player
          </p>
        )}
      </div>
    </SectionCard>
  );
}
